export enum MessageStyle {
  BLOCK = 'block',
  TEXT = 'text'
}
